import { render } from "./BlockButton.vue?vue&type=template&id=092e5866"
import script from "./BlockButton.vue?vue&type=script&lang=js"
export * from "./BlockButton.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./BlockButton.vue?vue&type=style&index=0&id=092e5866&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script